export default __webpack_public_path__ + "media/images/home/slide_ninki_sm-2032714b18acd8047605424218105f7f.png";